import {Component, HostListener, OnInit} from '@angular/core';

@Component({
  selector: 'awair-more-button',
  templateUrl: './more-button.component.html',
  styleUrls: ['./more-button.component.scss']
})

export class MoreButtonComponent implements OnInit {
  @HostListener('mouseover') mouseOver() {
    this.color = '#ACB4BB';
  }

  @HostListener('mouseout') mouseOut() {
    this.color = '#CDD3D8';
  }

  color: string = '#CDD3D8';

  constructor() {
  }

  ngOnInit() {
  }
}
